/**
 * Normalize tenant active state from various field formats
 * Handles: is_active (boolean/string/number), isActive, status, state, disabled_at, enabled
 */
export function getIsActive(tenant) {
  if (!tenant) return false;
  
  // Check boolean is_active or isActive
  if (typeof tenant.isActive === 'boolean') return tenant.isActive;
  if (typeof tenant.is_active === 'boolean') return tenant.is_active;
  
  // Check string is_active
  if (typeof tenant.is_active === 'string') {
    return tenant.is_active.toLowerCase() === 'true';
  }
  
  // Check number is_active (1 = active, 0 = inactive)
  if (typeof tenant.is_active === 'number') {
    return tenant.is_active === 1;
  }
  
  // Check disabled_at (if exists and not null, tenant is disabled)
  if (tenant.disabled_at !== undefined) {
    return tenant.disabled_at == null;
  }
  
  // Check enabled field
  if (tenant.enabled !== undefined) {
    return !!tenant.enabled;
  }
  
  // Check status field
  if (tenant.status) {
    return String(tenant.status).toLowerCase() === 'active';
  }
  
  // Check state field
  if (tenant.state) {
    return String(tenant.state).toLowerCase() === 'active';
  }
  
  // Default to false (inactive)
  return false;
}

/**
 * Get toggle button label based on active state
 */
export function getToggleLabel(tenant) {
  const isActive = getIsActive(tenant);
  return isActive ? 'Pasifleştir' : 'Aktifleştir';
}

/**
 * Get toggle button class based on active state
 */
export function getToggleButtonClass(tenant) {
  const isActive = getIsActive(tenant);
  return isActive 
    ? 'text-yellow-600 hover:bg-yellow-50' 
    : 'text-green-600 hover:bg-green-50';
}

/**
 * Get toggle action based on active state
 */
export function getToggleAction(tenant) {
  const isActive = getIsActive(tenant);
  return isActive ? 'suspend' : 'activate';
}
